export default "__VITE_ASSET__D70HTrBP__"